import React, {Fragment, memo} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SubCategories = ({categories, min, max}) => (
  <Fragment>
    {
      categories.slice(min, max).map(({ID, post_title, permanlink, selected, categorySelected}) => {
        const subCategoriesClass = classNames('pl-2', {
          'text-primary': selected,
          'text-dark': !selected,
          'line-selected': categorySelected
        });

        return (
          <div key={ID} className="p-1 text-truncate position-relative">
            <a className={subCategoriesClass} href={permanlink} title={post_title}>{post_title}</a>
          </div>
        );
      })
    }
  </Fragment>
);

SubCategories.propTypes = {
  categories: PropTypes.array.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired
};

export default memo(SubCategories);
